module.exports = "<div id=\"kt_body\" class=\"header-fixed header-mobile-fixed subheader-enabled subheader-fixed aside-enabled aside-fixed aside-minimize-hoverable page-loading\">\n  <cpwd></cpwd>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/resetPassword/resetPassword.html
// module id = 502
// module chunks = 0